import React from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import GuideBar from './GuideBar';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import styles from './styles.module.scss';

const BraGuide = ({ tags, productType }: { tags: string[]; productType: string }) => {
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });
  const braTags = tags.filter((tag) => tag.toLowerCase().startsWith('support:'));
  const isBraGuideEligible =
    productType.toLowerCase().startsWith('women:bras') || productType.toLowerCase().startsWith('women:tops');

  if (braTags.length < 1 && !isBraGuideEligible) return null;

  const braLevelTagArray = braTags[0]?.split(':');

  const braLevel = braLevelTagArray ? braLevelTagArray[braLevelTagArray.length - 1]?.trim() : null;
  if (!braLevel) return null;

  const BraLevelArray: Record<string, number[]> = {
    'low support/coverage': [1, 1, 0, 0, 0, 0],
    'low-medium support/coverage': [0, 1, 1, 0, 0, 0],
    'medium support/coverage': [0, 0, 1, 1, 0, 0],
    'medium-high support/coverage': [0, 0, 0, 1, 1, 0],
    'high support/coverage': [0, 0, 0, 0, 1, 1],
  };

  return (
    <Grid container direction="row" xs={!isMobile ? 12 : 'auto'} className={styles.guideBarContainer}>
      <Grid xs={isMobile ? 12 : 'auto'}>
        <Grid item xs={isMobile ? 'auto' : 12} className={styles.braGuideTitle}>
          <span>Bra Support guide</span>
        </Grid>
        <Grid item xs={12}>
          <GuideBar
            guideMapping={BraLevelArray[braLevel.toLowerCase()]}
            labels={['Light', 'Medium', 'High']}
            ariaLabel={braLevel}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BraGuide;
